type EnumObject = {[key: string]: number | string};
type EnumObjectEnum<E extends EnumObject> = E extends {[key: string]: infer ET | string} ? ET : never;

export default function getEnumKeys<T extends EnumObject>(E: T): EnumObjectEnum<T>[] {
   const keys = Object.keys(E).filter(k => typeof E[k] === "number");
   const values = keys.map(k => E[k] as EnumObjectEnum<T>);

   return values;
}